import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Building2, Landmark, Globe } from "lucide-react";

const Footer = () => {

    const quickLinks = [
        { name: "Home", path: "/" },
        { name: "About Us", path: "/about-us" },
        { name: "Contact Us", path: "/contact-us" },
        { name: "Binary Plan", path: "/plan" },
        { name: "Terms & Condition", path: "/terms-condition" },
    ];

    const keyContacts = [
        { name: "Dr. M. Rajaram, Managing Director", phones: ["+91 80565 82731", "+91 73737 37910"] },
    ];

    const adminContacts = [
        { name: "M. Nagajothi", phone: "+91 81483 92242" },
        { name: "Veera Chinnammal", phone: "98944 39225" }
    ];

    return (
        <footer className="bg-slate-900 border-t border-cyan-500/20">
            {/* Main Footer Content */}
            <div className="px-6 py-12">
                <div className="max-w-7xl mx-auto">
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">

                        {/* Admin Contact & Web/Email */}
                        <div>
                            <div className="flex items-center gap-2 mb-6">
                                <Phone className="w-5 h-5 text-yellow-400" />
                                <h4 className="text-lg font-bold text-yellow-400">Admin Contact</h4>
                            </div>
                            <div className="space-y-3 mb-6">
                                {adminContacts.map((contact, index) => (
                                    <div key={index}>
                                        <p className="text-white font-medium text-sm">{contact.name}</p>
                                        <p className="text-gray-400 text-sm">{contact.phone}</p>
                                    </div>
                                ))}
                            </div>

                            <div className="mb-8">
                                <div className="flex items-center gap-2 mb-6">
                                    <Phone className="w-5 h-5 text-yellow-400" />
                                    <h4 className="text-lg font-bold text-yellow-400">Key Contacts</h4>
                                </div>
                                <div className="space-y-4">
                                    {keyContacts.map((contact, index) => (
                                        <div key={index}>
                                            <p className="text-white font-medium text-sm mb-2">{contact.name}</p>
                                            {contact.phones.map((phone, phoneIndex) => (
                                                <p key={phoneIndex} className="text-gray-400 text-sm">{phone}</p>
                                            ))}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                        {/* Key Contacts and Bank Details */}
                        <div>
                            {/* Bank Details */}
                            <div>
                                <div className="flex items-center gap-2 mb-4">
                                    <Landmark className="w-5 h-5 text-yellow-400" />
                                    <h4 className="text-lg font-bold text-yellow-400">Bank Details</h4>
                                </div>
                                <div className="bg-slate-800/50 rounded-lg p-4 border border-cyan-500/20">
                                    <p className="text-white font-bold text-sm mb-3">GATEWAY PROMOTERS</p>
                                    <div className="space-y-2 text-sm">
                                        <p className="text-gray-400">
                                            <span className="text-white font-semibold">Bank:</span> ICICI BANK, Periyakulam Branch
                                        </p>
                                        <p className="text-gray-400">
                                            <span className="text-white font-semibold">A/C No:</span> 621605020040
                                        </p>
                                        <p className="text-gray-400">
                                            <span className="text-white font-semibold">IFSC:</span> ICIC0006216
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <br />
                            <div className="space-y-2">
                                <div className="flex items-start gap-2">
                                    <Globe className="w-4 h-4 text-cyan-400 mt-0.5 flex-shrink-0" />
                                    <div>
                                        <p className="text-white text-xs font-semibold mb-1">Web:</p>
                                        <p className="text-gray-400 text-xs">www.gatewaypromoters.com</p>
                                    </div>
                                </div>
                                <div className="flex items-start gap-2">
                                    <Mail className="w-4 h-4 text-cyan-400 mt-0.5 flex-shrink-0" />
                                    <div>
                                        <p className="text-white text-xs font-semibold mb-1">Email:</p>
                                        <p className="text-gray-400 text-xs">gatewaypromoters1@gmail.com</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Quick Links - Centered */}
                        <div className="flex flex-col items-center text-center">
                            <h4 className="text-lg font-bold text-yellow-400 mb-6">Quick Links</h4>
                            <ul className="space-y-3">
                                {quickLinks.map((link, index) => (
                                    <li key={index}>
                                        <Link
                                            to={link.path}
                                            className="text-gray-400 hover:text-cyan-400 transition-colors duration-200 text-sm"
                                        >
                                            {link.name}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Corporate Office Address with Building Image */}
                        <div>
                            <div className="flex items-center gap-2 mb-6">
                                <Building2 className="w-5 h-5 text-yellow-400" />
                                <h4 className="text-lg font-bold text-yellow-400">Corporate Office</h4>
                            </div>

                            {/* Building Image */}
                            {/* <div className="bg-white rounded-lg p-4 mb-4">
                                <img
                                    src="/images/building.jpeg"
                                    alt="Gateway Promoters Corporate Office"
                                    className="w-full h-auto rounded"
                                    onError={(e) => {
                                        e.target.style.display = 'none';
                                        e.target.nextSibling.style.display = 'flex';
                                    }}
                                />
                                <div className="hidden items-center justify-center h-32 bg-slate-800 rounded">
                                    <Building2 className="w-16 h-16 text-cyan-400" />
                                </div>
                            </div> */}

                            <div className="bg-slate-800/50 rounded-lg p-4 border border-cyan-500/20">
                                <p className="text-white font-bold text-sm mb-3">GATEWAY PROMOTERS,</p>
                                <p className="text-gray-400 text-sm leading-relaxed">
                                    1B Bhavathi Amman Kovil Street,<br />
                                    Vadakadu, Periyakulam,<br />
                                    Theni District, Tamil Nadu - 625601
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Bottom Bar */}
            <div className="px-6 py-4 bg-slate-800 border-t border-slate-700">
                <div className="max-w-7xl mx-auto">
                    <div className="text-center">
                        <p className="text-gray-400 text-sm">
                            © 2024 Gateway Promoters. All rights reserved.
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;